export const PREVIEW_INITIAL =
  "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

export const generateProjectId = () => {
  const timestamp = new Date().getTime();
  const randomPart = Math.random().toString(36).slice(2);
  return timestamp.toString(36) + randomPart;
};

export const LAYOUTS = {
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait",
  SQUARE: "square",
};

export const ANIMATIONS = {
  NONE: "none",
  RIGHT: "right",
  LEFT: "left",
  UP: "up",
  DOWN: "down",
  // FADE: "fade",
};

export const DEFAULT_PROJECT_NAMES = {
  template: "New template",
  "user-template": "My new template",
  project: "My new project",
};

export const AUDIO_FILE_BASE_URL = process.env.REACT_APP_SERVER_API_URL;
